import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { mapState } from "vuex";
import ForgotPasswordDialog from "@/views/modals/forgot-password";
import { VueRecaptcha } from 'vue-recaptcha';

// No message specified.
extend("email", email);

// Override the default message.
extend("required", {
  ...required,
  message: "This field is required",
});

export default {
  computed: {
    ...mapState({
      status: (state) => state.Authenticate.status,
    }),
  },
  data: () => ({
    widgetId:"",
    reset:"",
    execute:"",
    root:"",
    sitekey: '6LcozJwhAAAAAAdQ2UEIvMWXNTKWmVmAPNH9SPDP',
    form:{
      robot: false,
    },
    showForgotPassword: false,
    validation_message: "",
    valid: false,
    user: {
      email: "",
      password: "",
    },
    show1: "",
    logo:require('../../assets/Frame.svg'),
    background_image:require('../../assets/login_home.png')
  }),
  methods: {
    async login() {
      const self = this;
      if (self.form.robot) {
        const valid = await this.$refs.validator.validate();
        self.setValidationMessage("");
        if (valid) {
         await self.$store
            .dispatch("Authenticate/login", self.user)
            .then((value) => {
              if (value) {
                if (value.user_role === "admin_enterprise") {
                  self.$router.push("/admin/companies");
                } else {
                  self.$router.push("/admin/users");
                }
              }
            })
            .catch(() => {
              self.setValidationMessage("Invalid email/password");
            });
        }
      }
    },
    setValidationMessage(message) {
      this.validation_message = message;
    },
    hideForgotPassword() {
      this.showForgotPassword = false;
    },
    onVerify: function (response) {
      if (response) this.form.robot = true;
    },
    onExpired: function () {
      this.$refs.recaptcha.reset()
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    ForgotPasswordDialog,
    VueRecaptcha
  },
};
